import { Icons } from '../../ds';
import type { ShellMenuItem } from '../../ds';
import type { RenderMode } from '../../astromark';

const MODE_ITEMS: { mode: RenderMode; label: string }[] = [
    { mode: 'auto', label: 'Renderer: Auto' },
    { mode: 'markdown-it', label: 'Renderer: Markdown (legacy)' },
    { mode: 'astromark', label: 'Renderer: AstroMark' },
];

/**
 * The account menu's "Renderer" group (after Theme): Auto (the page's own format), Markdown (legacy, markdown-it) and
 * AstroMark; the current one carries the check, the others keep its width.
 */
export function renderModeMenuItems(mode: RenderMode, setMode: (mode: RenderMode) => void): ShellMenuItem[] {
    return MODE_ITEMS.map((item, index) => ({
        label: item.label,
        icon: item.mode === mode ? <Icons.check /> : <span className="ark-menu-icon-spacer" />,
        onClick: () => setMode(item.mode),
        separatorBefore: index === 0,
    }));
}
